import { render } from "./MdDialogTitle.vue?vue&type=template&id=515eb54b"
import script from "./MdDialogTitle.vue?vue&type=script&lang=js"
export * from "./MdDialogTitle.vue?vue&type=script&lang=js"

import "./MdDialogTitle.vue?vue&type=style&index=0&id=515eb54b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__